module.exports = __webpack_public_path__ + "img/footer_icon2.cbc50c38.png";